<template>
  <div class="content-notice" v-html="txt"></div>
</template>

<script>
export default {
  name: "ContentNotice",
  props:{
    txt:{
      type:String,
      default:''
    }
  },
  data(){
    return{
      text:""
    }
  }
}
</script>

<style scoped>
</style>
